<template>
  <div class="order-0 order-2 order-xl-1
              brand-img-cont wp_headerItemsAlign"
  >
    <div id="wp_homepage_headerLogo" class="navbrand">
      <a href=""
									@click.prevent="homeRedirection"
									id="logo-container-img-link"
									data-test="logoContainerLink1">
        <img src="@/assets/img/neobank.png"
													alt="site-logo"
													id="logoContainerImg1"
													data-test="logoContainerImg1">
      </a>
    </div>
  </div>
</template>
<script>
export default {
	methods: {
		homeRedirection () {
			if (document.getElementById('wp_CategoryNav') &&
        document.getElementById('wp_CategoryNav').style) {
				document.getElementById('wp_CategoryNav').style.top = '59px'
			}
			this.$router.push({ name: 'Home' })
		}
	}
}
</script>
